<template>
  <ul
    class="product__highlights list-inside leading-relaxed pl-2"
  >
    <li
      v-for="highlight in value"
      :key="highlight"
    >
      {{ highlight }}
    </li>
  </ul>
</template>

<script lang="ts">

import type { PropType } from 'vue';

export default defineComponent({
  name: 'ProductHighlights',
  props: {
    value: {
      type: Array as PropType<Array<string>>,
      required: true,
      validator: (value: string[]) => {

        // check if array has only one level
        return !!value.find(v => typeof v === 'string');
      
      },
    },
  },
});

</script>
